module.exports = __webpack_public_path__ + "assets/img/biao1.40d38686.png";